import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { LocaleService } from '@next/core-lib/i18n';
import { SelectedCustomer, SelectedLocation, UserSelectors } from '@next/core-lib/user';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { skipWhile, take } from 'rxjs/operators';

import { BrandingLogoSrc } from 'src/app/branding/branding.model';

import { getTenantName } from 'src/app/branding/store/branding.selectors';

import { AnimalCountCard, Flock } from '../../models/flock.model';
import { setSelectedFlockId } from '../../store/actions/flock.actions';

import { getSelectedFlock } from '../../store/selectors/flock.selectors';

@Component({
  selector: 'app-animal-count-report',
  templateUrl: './animal-count-report.component.html',
  styleUrls: ['./animal-count-report.component.scss'],
  standalone: false,
})
export class AnimalCountReportComponent {
  title: string;
  animalCountCards: AnimalCountCard[];
  years: number[];
  selectedYear: number;
  selectedAnimalCountCard: AnimalCountCard;
  customer$: Observable<SelectedCustomer> = this.store.select(UserSelectors.selectCustomer);
  location$: Observable<SelectedLocation> = this.store.select(UserSelectors.selectLocation);
  selectedFlock$: Observable<Flock> = this.store.select(getSelectedFlock);

  showAgrifirmLogo = true;
  customizedLogoSrc: string = BrandingLogoSrc.PoultryNextLogo;

  constructor(
    private readonly store: Store<RootState>,
    private readonly activatedRoute: ActivatedRoute,
    private router: Router,
    @Inject(LocaleService) private locale: LocaleService,
  ) {
    const id = Number(this.activatedRoute.snapshot.paramMap.get('id'));

    if (id > 0) {
      this.store.dispatch(setSelectedFlockId({ id, save: false, reloadWeekData: false }));
    }

    this.title = this.locale.translate('report.title_animalcount');
    this.activatedRoute.data
      .pipe(
        skipWhile((result) => result === null),
        take(1),
      )
      .subscribe((result) => {
        this.animalCountCards = <AnimalCountCard[]>result.animalCountCards;
        this.years = this.animalCountCards.map((card) => card.year);
      });

    this.store
      .select(getTenantName)
      .pipe(take(1))
      .subscribe((tenantName) => {
        if (tenantName === 'Agravis') {
          this.customizedLogoSrc = BrandingLogoSrc.AgravisLogo;
          this.showAgrifirmLogo = false;
        }
      });
  }

  print() {
    const pageTitle = document.title;
    const printTitle = `${this.locale.translate('title')} ${this.title} - ${formatDate(
      Date(),
      'dd-MM-yyyy',
      this.locale.getLocale(),
    )}`;
    if (window) {
      document.title = printTitle;
      window.print();
      document.title = pageTitle;
    }
  }

  changeYear() {
    this.selectedAnimalCountCard = this.animalCountCards.find(
      (card) => card.year === this.selectedYear,
    );
    this.title = `${this.locale.translate('report.title_animalcount')} ${this.selectedYear}`;
  }

  back() {
    this.router.navigate(['/flock']);
  }
}
